(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nakis-team-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nakis-team-card')) {
    customElements.define('nakis-team-card', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.requestNumber = 0;
        this.image = this.querySelector('.nakis-team-card__image');
        this.buttons = [...this.querySelectorAll('[data-team]')];
        this.status = this.querySelector('[role="status"]');
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-team]');
          if (button && this.contains(button)) this.select(button);
        });
        const current = this.buttons.find(button => button.getAttribute('aria-pressed') === 'true');
        if (current) this.commit(current);
        try {
          const saved = sessionStorage.getItem('nakis-team:' + this.dataset.product);
          const match = this.buttons.find(button => button.dataset.team === saved);
          if (match && match !== current) this.select(match);
        } catch {}
      }
      commit(button) {
        this.buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.status.textContent = button.dataset.label;
        this.querySelectorAll('.nakis-team-card__link').forEach(link => {
          const url = new URL(link.href, window.location.href);
          url.searchParams.set('nakis_team', button.dataset.team);
          link.href = url.toString();
        });
      }
      async select(button) {
        if (!this.image) return;
        const request = ++this.requestNumber;
        this.setAttribute('aria-busy', 'true');
        const next = new Image();
        next.sizes = this.image.sizes;
        next.srcset = button.dataset.srcset || '';
        next.src = button.dataset.src;
        try {
          await next.decode();
          if (request !== this.requestNumber || !this.isConnected) return;
          this.image.srcset = next.srcset;
          this.image.src = next.src;
          this.image.alt = button.dataset.label + ' — ' + this.querySelector('h3').textContent.trim();
          this.commit(button);
          try { sessionStorage.setItem('nakis-team:' + this.dataset.product, button.dataset.team); } catch {}
        } catch {
          if (request === this.requestNumber) this.status.textContent = this.dataset.error;
        } finally {
          if (request === this.requestNumber) this.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nakis-team-prefill"] && !Shopify.designMode) return;
  try {
    (() => {
    const teams = {'sari-kirmizi':'SARI-KIRMIZI','sari-lacivert':'SARI-LACİVERT','siyah-beyaz':'SİYAH-BEYAZ'};
    const team = teams[new URLSearchParams(window.location.search).get('nakis_team')];
    if (!team) return;
    let finished = false;
    let queued = false;
    let observer;
    let timer;
    const clean = () => {
      finished = true;
      observer?.disconnect();
      clearTimeout(timer);
      document.removeEventListener('pointerdown', onInteraction, true);
      document.removeEventListener('keydown', onInteraction, true);
    };
    const onInteraction = (event) => {
      if (event.isTrusted && event.target.closest('.tpo_option-container')) clean();
    };
    const attempt = () => {
      queued = false;
      if (finished) return;
      const fields = [...document.querySelectorAll('input[name="properties[Takım Seçimi]"]')];
      const field = fields.find(item => item.closest('.tpo_option-container')?.getClientRects().length);
      if (!field) return;
      const container = field.closest('.tpo_option-container');
      const radio = [...container.querySelectorAll('input.tpo_radio-button[type="radio"]')].find(item => item.value === team && !item.disabled);
      if (!radio) return;
      if (radio.checked && field.value === team) { clean(); return; }
      const label = radio.closest('label');
      if (!label) return;
      label.dispatchEvent(new PointerEvent('pointerup', {bubbles:true}));
      if (radio.checked && field.value === team) clean();
    };
    const start = () => {
      observer = new MutationObserver(() => {
        if (finished || queued) return;
        queued = true;
        requestAnimationFrame(attempt);
      });
      observer.observe(document.body, {childList:true, subtree:true});
      document.addEventListener('pointerdown', onInteraction, true);
      document.addEventListener('keydown', onInteraction, true);
      timer = setTimeout(clean, 20000);
      attempt();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
